import { render, staticRenderFns } from "./SalesOrderDetailModal.vue?vue&type=template&id=516d31f6&scoped=true"
import script from "./SalesOrderDetailModal.vue?vue&type=script&lang=ts"
export * from "./SalesOrderDetailModal.vue?vue&type=script&lang=ts"
import style0 from "./SalesOrderDetailModal.vue?vue&type=style&index=0&id=516d31f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516d31f6",
  null
  
)

export default component.exports